<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "./question.vue";
import Changefloor from "./questionfloor.vue";
export default {
  extends: baseEdit,
  components: {
    change: Change,
    Changefloor:Changefloor
  },
  data() {
    return {
      mname: "offices",
      key: "id",
      url: {
        // get: '/admin/system/desk',
        // add: "/admin/system/desk",
        // edit: "/admin/system/desk",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "是否存在父级",
          name: "isParent",
          type: "select",
          width: "400px",
          value: "0",
          dropList: [
            {
              value: "0",
              name: "否",
            },
            {
              value: "1",
              name: "是",
            },
          ],
          onChange: this.onisParent,
        },
         {
          label: "所属部门",
          name: "department",
          type: "select",
          width: "400px",
          value: "0",
          dropList: [
            {
              value: "0",
              name: "急诊",
            },
            {
              value: "1",
              name: "门诊",
            },
            {
              value: "2",
              name: "住院",
            },
            {
              value: "3",
              name: "医技",
            },
            {
              value: "4",
              name: "行政",
            },
          ],
          rules: [{ required: true, trigger: "blur" }],
          // onChange: this.onisParent,
        },
        {
          label: "父级科室",
          name: "parentId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          onChange: this.onparentId,
        },
        {
          label: "科室名称",
          name: "deskName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "楼宇",
          name: "building",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "楼层",
          name: "address",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        // {
        //   label: "楼宇",
        //   name: "building",
        //   value: "",
        //   type: "pullbuilding",
        //   width: "400px",
        //   rules: [{ required: true, trigger: "blur" }],
        //   onExtClick: this.onTextExtClick,
        // },
        // {
        //   label: "楼层",
        //   name: "address",
        //   value: "",
        //   type: "pullfloor",
        //   width: "400px",
        //   rules: [{ required: true, trigger: "blur" }],
        //   onExtClick: this.onTextExtClick1,
        // },
        // {
        //   label: "房间号",
        //   name: "deskRoom",
        //   value: "",
        //   type: "input",
        //   width: "400px",
        // },
        {
          label: "科室电话",
          name: "phone",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "负责人",
          name: "principal",
          value: "",
          type: "input",
          width: "400px",
        },
      ],
      forms: {
        building:"",
        address:"",
      },
    };
  },
  // computed: {
  //   extRender() {
  //     return ["change","Changefloor"];
  //   },
  // },
  created() {
    this.loadLevelData()
    let query = this.$route.query
    if (query.action == 'edit') {
      this.items[this.getItemIndex('isParent')].disabled = true
      this.items[this.getItemIndex('parentId')].disabled = true
    }
  },
  mounted() {
    this.onisParent("0");
    this.forms.state = "0";
    this.items[this.getItemIndex("parentId")].value = "0";
  },
  methods: {
    onTextChange(val) {
    },
    onTextFocus() {
    },
    onTextExtClick(v) {
      let _this = this
        _this.$refs.change[0].loadData()
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.Changefloor[0].close()
          this.$refs.change[0].open()
          this.$refs.change[0].getText = (val) => {
            this.forms.building = val
          }
        }
    },
    onTextExtClick1(v) {
      let _this = this
        _this.$refs.Changefloor[0].loadData()
        // 按钮显示常用语
        if (this.$refs.Changefloor && this.$refs.Changefloor[0]) {
          this.$refs.change[0].close()
          this.$refs.Changefloor[0].open()
          this.$refs.Changefloor[0].getText = (val) => {
            this.forms.address = val
          }
        }
    },
    onisParent(val) {
      if (val == "0") {
        this.items[this.getItemIndex("parentId")].type = "kong";
      }
      if (val == "1") {
        this.items[this.getItemIndex("parentId")].type = "select";
      }
    },
    onparentId(val){
       if(val){
       $utils.api.load(`/admin/system/desk/${val}`, {}).then((res) => {
        if (res && res.data) {
          this.parentName = res.data.deskName;
        }
      });
      }
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/desk/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          if (this.forms.isParent === "1") {
            this.items[this.getItemIndex("parentId")].type = "select";
          }
          if (this.forms.isParent === "0") {
            this.items[this.getItemIndex("parentId")].type = "kong";
          }
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      //if(this.forms.parentId===this.forms.id){
       // $utils.toast.error("同一科室不能绑定自身！");
       // return true;
      //}
      let q = this.forms;
      q.parentName=this.parentName
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/desk`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {}
      $utils.api.load(`/admin/system/desk/selectList?isParent=${"0"}`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows
          let dropList = []
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index]
            let xx = {}
            xx.value = element.id
            xx.name = element.deskName
            xx.children = element.children || []
            dropList.push(xx)
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index]
            if (element && element.name == 'parentId') {
              // this.items[index]['dropList'] = dropList
              this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
            }
          }
        }
      })
    },
  },
};
</script>
